<template>
    <div
        class="l-ss-c-results-info"
        :class="{
            'l-ss-c-results-info-with-message': hasAutocompleteElements || !totalItemsCount,
            'l-ss-c-results-info-only-results': totalItemsCount && !hasAutocompleteElements && !hasTips,
            'l-ss-c-results-info-with-tips': hasTips,
            'l-ss-c-results-info-with-autocomplete': hasAutocompleteElements,
        }">
        <div class="l-ss-c-results-info-left-section">
            <div
                class="l-ss-c-results-info-header"
                v-if="message || hasAutocompleteElements">
                <span
                    v-if="message"
                    class="l-ss-c-results-info-help-text"
                    v-html="message">
                </span>

                <span
                    class="l-ss-c-results-info-autocomplete-items"
                    v-if="showAutocompleteElements && hasAutocompleteElements && !isStandardSearchType">
                    <span
                        v-for="item in list"
                        :key="item"
                        class="l-ss-c-results-info-autocomplete-item"
                        @click="() => handleSearch(item)">{{ item }}
                    </span>
                </span>
            </div>

            <section-results-info-tips
                v-if="hasTips"
                :search="search"
                @handle-tags-click="$emit('handle-tags-click', $event)"
                @result-tab-click="$emit('result-tab-click', $event)"/>
        </div>

        <div
            class="l-ss-c-results-info-count"
            v-if="totalItemsCount">
            {{ foundItemsMessage }}
        </div>
    </div>
</template>

<script>
    import { computed } from '@vue/composition-api';
    import SectionResultsInfoTips from '@/core/components/section-results/section-results-info-tips.vue';

    export default {
        components: {
            SectionResultsInfoTips,
        },
        props: {
            search: {
                type: Object,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            showAutocompleteElements: {
                type: Boolean,
                default: true,
            },
        },
        setup(props, { emit, root }) {
            const hasAutocompleteElements = computed(() => {
                return props.search
                    && props.search.suggestions
                    && !!props.search.suggestions.length;
            });

            const list = computed(() => {
                return props.search?.suggestions || [];
            });

            const hasTips = computed(() => {
                return !!props.search?.tips?.length;
            });

            const isNarrowSearchType = computed(() => {
                return props.search?.meta?.searchType[0]?.startsWith('narrow');
            });

            const isStandardSearchType = computed(() => {
                return props.search?.meta?.searchType[0]?.startsWith('standard');
            });

            const isWildcardSearchType = computed(() => {
                return props.search?.meta?.searchType[0]?.startsWith('wildcard');
            });

            const message = computed(() => {
                if (!props.totalItemsCount && !isNarrowSearchType.value) {
                    return root.$t('noResultsFoundMessage', { 0: props.search.query });
                }

                if (hasAutocompleteElements.value && (isNarrowSearchType.value || isStandardSearchType.value || isWildcardSearchType.value)) {
                    return root.$t('autocomplete.similar', { 0: props.search.query });
                }

                if (!hasAutocompleteElements.value && (isStandardSearchType.value || isWildcardSearchType.value)) {
                    return root.$t('searchType.similarSearchResultsMessage');
                }

                return '';
            });

            const foundItemsMessage = computed(() => {
                return `${root.$t('results.foundResults')}: ${props.totalItemsCount}`;
            });

            const handleSearch = (value) => {
                emit('autocomplete-search', value);
            };

            return {
                hasAutocompleteElements,
                list,
                hasTips,
                message,
                foundItemsMessage,
                handleSearch,
                isStandardSearchType,
            };
        },
    };
</script>

<style scoped>

</style>
